import { render, staticRenderFns } from "./ValidaCotizacion.vue?vue&type=template&id=4940bf5f&scoped=true"
import script from "./ValidaCotizacion.vue?vue&type=script&lang=js"
export * from "./ValidaCotizacion.vue?vue&type=script&lang=js"
import style0 from "./ValidaCotizacion.vue?vue&type=style&index=0&id=4940bf5f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940bf5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4940bf5f')) {
      api.createRecord('4940bf5f', component.options)
    } else {
      api.reload('4940bf5f', component.options)
    }
    module.hot.accept("./ValidaCotizacion.vue?vue&type=template&id=4940bf5f&scoped=true", function () {
      api.rerender('4940bf5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/validaInfo/ValidaCotizacion.vue"
export default component.exports